<template>
  <Modal
    :id="'cmp-royalty-royalty_account-sidewindow-add_contract_form'"
    @cancelled="onCancel"
  >
    <template slot="header">New B2B Access</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <!-- <TextField
            :id="'posting_number'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="cost.json_data.posting_number"
            isModel
            :placeholder="$t('posting_number')"
            @valuechanged="onPostingNumberChange"
            :disabled="formDisabled"
            showValidationIcons
            required
            :validators="postingNumberValidators"
            @validated="onValidation"
          /> -->
          <TextField
            :id="'user_name'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="external_user.user_name"
            isModel
            :placeholder="$t('user_name')"
            @valuechanged="onUserNameChange"
            showValidationIcons
            required
            :validators="uniqueNameValidator"
            @validated="onValidation"
          />
          <TextField
            :id="'given_name'"
            class="m1"
            v-bind="textFieldConfig"
            :value="external_user.given_name"
            required
            showValidationIcons
            :placeholder="$t('given_name')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'email'"
            class="m1"
            v-bind="textFieldConfig"
            type="email"
            :value="external_user.email"
            required
            showValidationIcons
            :placeholder="$t('email')"
            :validators="emailValidators"
            @valuechanged="onEmailChange"
            @validated="onValidation"
          />
        </div>
      </div>
      <span style="color: red">
        By clicking on SAVE, you confirm that this EXTERNAL USER will have
        access to ROYALTY STATEMENTS! The charts & statements contain sensitive
        information like sales / contracts / royalties / payments. If you wish
        to cancel this access, you can do so here at any time!
      </span>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button
      :disabled="!isFormValid"
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onOkClick"
      >
        Ok
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import { AccountsService } from "../../services/accounts.service";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapActionObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import { subscribeSubject } from "../../../../utility";
import { Subject } from "rxjs";
import {
  NotificationService,
} from "../../../../dt-plugins/notification/notification.service";
import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";
import { createValidator } from "@plugins/text-field";
import isEmail from "validator/lib/isEmail";

export default {
  components: {
    Modal,
    InputField,
  },
  props: ["selectedAccountDetails"],
  data() {
    return {
      external_user: this.get_external_user(),
      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        //showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        // valueChangedEvent: EventHooks.OnKeyup,
      }),

  
      validationResult: {},
      userNameSubject: new Subject(),
      emailNameSubject: new Subject(),
      duplicateUserName: "",
      duplicateEmail: null,
      
    };
  },
  mounted() {
    subscribeSubject(this, this.userNameSubject, async (value) => {
      const checkUnique = await AccountsService.checkUniquenessOfExternalUser(
        value
      );
      const is_unique = checkUnique.data.is_unique;
      if (!is_unique) {
        this.duplicateUserName = value;
        const temp = this.external_user.user_name;
        this.external_user.user_name = null;
        this.$nextTick(() => {
          this.external_user.user_name = temp;
        });
      }
      
    });
    subscribeSubject(this, this.emailNameSubject, async (value) => {
      this.duplicateEmail=null;
      const checkUnique = await AccountsService.checkUniquenessOfExternalUserEmail(
        value
      );
      const is_email_taken = checkUnique.data.is_email_taken;
      if(is_email_taken){
        this.duplicateEmail=value;
        this.external_user.email = null;
        this.$nextTick(() => {
          this.external_user.email = value;
        });
        NotificationService.showNotification({
        text: this.$t('external_user_email_taken'),
        timeout: 3000,
        type: "error",
      });
      }
      
      
    });
  },
  computed: {
    uniqueNameValidator() {
      return [
        createValidator({
          name: "uniqName",
          validatorFn: this.checkUserNameUniq,
          errorMessage: "Name is already exist",
        }),
      ];
    },
    emailValidators() {
      return [
      createValidator({
          name: "emailValidation",
          validatorFn: isEmail,
          errorMessage: "Must be a valid Email",
        }),
        createValidator({
          name: "uniqEmail",
          validatorFn: this.checkEmailUniq,
          errorMessage: "Email is already exist",
        }),
      ];
    },

    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    royalty_account_id: function () {
      return this.$route.params.royalty_account_id;
    },

    isDisabled() {
      return (
        this.external_user.user_name &&
        this.external_user.given_name &&
        this.external_user.email
      );
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    async onUserNameChange(name, value) {
      this.external_user.user_name = value;
      this.userNameSubject.next(value);
    },
    async onEmailChange(name, value) {
      if(isEmail(value)){
        this.external_user.email = value;
        this.emailNameSubject.next(value);
      }
      
    },
    checkUserNameUniq(value) {
      return value == this.duplicateUserName ? false : true;
    },
    checkEmailUniq(value) {
      return value == this.duplicateEmail ? false : true;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onValueChange: async function (name, value) {
      this.external_user[name] = value;
    },

    onTextFieldValueChange(name, value) {
      this.external_user[name] = value;
    },
    onOkClick: async function () {
      const res = await AccountsService.newExternalUser({
        ...this.external_user,
      });
      console.log(res);
      if (res.data.external_user_id > 0) {
        const res1 = await AccountsService.addExternalUser(
          this.selectedAccountDetails?.account?.royalty_account_id,
          res.data.external_user_id
        );
        if (res1.data.done == 1) {
          const res2 = await AccountsService.fetchRoyaltyExternalUsers(
            this.selectedAccountDetails?.account?.royalty_account_id
          );

          this.$emit("added", res2.data.related_ext_users);
        }
      }

      this.onCancel();
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    get_external_user: function () {
      return {
        user_name: "",
        given_name: "",
        email: "",
      };
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_account-sidewindow-add_contract_form {
  .body-container {
    padding-bottom: 10px;
  }
  .form-group .input_box {
    padding: 2px 5px;
  }
  .form-group .label_box {
    padding: 2px 5px;
    color: rgba(70, 70, 70, 0.77);
  }
}
</style>
